import { render } from "./AddUserReportCompleted.vue?vue&type=template&id=644fa860&scoped=true"
import script from "./AddUserReportCompleted.vue?vue&type=script&lang=js"
export * from "./AddUserReportCompleted.vue?vue&type=script&lang=js"

import "./AddUserReportCompleted.vue?vue&type=style&index=0&id=644fa860&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644fa860"]])

export default __exports__